
import clientAuth from "../clientAuth"
export default {
    index: () => clientAuth.get(`restricteddate/index`), 
    store: (userData) => clientAuth.post('restricteddate/store', { json: userData }),       
    show:(id)=>clientAuth.get(`restricteddate/show/${id}`),
    update: (id,userData) => clientAuth.post(`restricteddate/update/${id}`, { json: userData }),
    destroy: (id) => clientAuth.delete(`restricteddate/destroy/${id}`),
};